<template>
    <transition name="modal">
        <div class="modal__mask modalRepresentantes" v-if="showModalCreate">
            <div class="modal__wrapper">
                <div class="modal__container" :style="rowResponseModal">
                    <div class="content__modal">
                        <div class="inner__modal_questionario">
                            <img style="width: 50px; height: 50px;" src="@/assets/questionario.png" />
                            <h2>Questionário Suitability </h2>


                            <form action="" class="form__class" @submit.stop.prevent="createRepresentante">

                                <div class="row-question">
                                    <div class="form__controls">
                                        <label class="label__field">
                                            {{questaoAtual.Pergunta}}
                                        </label>
                                    </div>
                                </div>

                                <div class="row-response" :class="{ 'scrollable': isScrollable }" v-if="questaoAtual.Respostas[0] != null && questaoAtual.Respostas[0].Opcoes.length == 0">
                                    <div class="row row-space-left" v-for="(resposta, index) in questaoAtual.Respostas" :key="index">
                                        <div class="form__controls">
                                            <div class="radio">
                                                <input
                                                    v-if="questaoAtual.TipoResposta != 'Múltipla escolha'"
                                                    type="radio"
                                                    :id="`${resposta.QuestionarioRespostaId}`"
                                                    :value="`${resposta.QuestionarioRespostaId}`"
                                                    class="field__radio"
                                                    :name="`questionario`"
                                                    @click="salvarAlteracoesLocalmente(resposta.QuestionarioRespostaId, questaoAtual.QuestionarioId)"
                                                />

                                                <input
                                                    v-if="questaoAtual.TipoResposta == 'Múltipla escolha' && resposta.TipoResposta != 'Múltipla Escolha'"
                                                    type="checkbox"
                                                    :id="`${resposta.QuestionarioRespostaId}`"
                                                    :value="`${resposta.QuestionarioRespostaId}`"
                                                    class="field__radio"
                                                    :name="`questionario`"
                                                    @click="salvarAlteracoesLocalmente(resposta.QuestionarioRespostaId, questaoAtual.QuestionarioId)"
                                                />


                                                  <input
                                                    v-if="questaoAtual.TipoResposta == 'Múltipla escolha' && resposta.TipoResposta == 'Múltipla Escolha'"
                                                    type="checkbox"
                                                    :id="`${resposta.QuestionarioRespostaId}`"
                                                    :value="`${resposta.QuestionarioRespostaId}`"
                                                    class="field__radio"
                                                    :name="`questionario`"
                                                    @click="salvarAlteracoesLocalmente(resposta.QuestionarioRespostaId, questaoAtual.QuestionarioId, 0, true)"
                                                />

                                                <label class="label__field" :for="`${resposta.QuestionarioRespostaId}`">
                                                    {{resposta.Descricao}}
                                                </label>
                                            </div>
                                        </div>
                                        
                                       <div v-if="resposta.TipoResposta == 'Múltipla Escolha' && this.listaRespostasAtivas.findIndex(r => 
            r.QuestionarioRespostaId === resposta.QuestionarioRespostaId && r.QuestionarioId === questaoAtual.QuestionarioId) > -1" style="margin-left: 20px; border: 1px solid #D0D5DD; border-radius: 8px; width: 90%;"> 
                                       <div class="row row-space-left" style="margin-bottom: 0px; " v-for="(subResposta, index) in resposta.Opcoes" :key="index">
                                         <div class="form__controls">
                                            <div class="radio">

                                               <input
                                                    type="checkbox"
                                                    :id="`${subResposta.QuestionarioRespostaOpcaoId}`"
                                                    :value="`${subResposta.QuestionarioRespostaOpcaoId}`"
                                                    class="field__radio"
                                                    :name="`questionario`"
                                                    @click="salvarAlteracoesLocalmente(resposta.QuestionarioRespostaId, questaoAtual.QuestionarioId, subResposta.QuestionarioRespostaOpcaoId)"
                                                />

                                                <label class="label__field" :for="`${subResposta.QuestionarioRespostaOpcaoId}`">
                                                    {{subResposta.Resposta}} 
                                                </label>

                                            </div>
                                        </div>
                                       </div>
                                       </div>

                                    </div>
                                </div>

                                <div class="row-response" :class="{ 'scrollable': isScrollable }" v-if="questaoAtual.Respostas[0] != null && questaoAtual.Respostas[0].Opcoes.length > 0">
                                
                                    <table class="table-modal">
                                        <thead>
                                        <th style="width: 20%">Item</th>
                                        <th style="width: 15%">Tipo</th>
                                        <th style="width: 15%">Classificação</th>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(resposta, index) in questaoAtual.Respostas" :key="index">
                                            <td>{{numeroQuestao + 1}}.{{index}}</td>
                                            <td>{{resposta.Descricao}}</td>
                                            <td>
                                                <select id="tipoCadastro" @change="salvarAlteracoesLocalmente(resposta.QuestionarioRespostaId, questaoAtual.QuestionarioId, $event.target.value)" class="field">
                                                     <option value="">Selecione</option>
                                                     <option v-for="item in resposta.Opcoes" :key="item.QuestionarioRespostaOpcaoId"  :value="item.QuestionarioRespostaOpcaoId">
                                                        {{ item.Resposta }}
                                                    </option>
                                                </select>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                
                                </div>

                                <div class="buttonsAcoes">         
                                        <button                               
                                            class="btnDefaultQuestionario"
                                            type="button"
                                            @click="closeModal"
                                        >
                                            Cancelar
                                        </button>           


                                        <button 
                                            v-if="questionario && (numeroQuestao + 1) < questionario.length"                                                              
                                            class="btnBlueQuestionario"
                                            type="button"
                                            @click="proximaQuestao()"
                                        >
                                            Próximo
                                        </button>   

                                        <button 
                                            v-if="questionario && (numeroQuestao + 1) == questionario.length"                                
                                            class="btnBlueQuestionario"
                                            type="button"
                                            @click="concluirQuestionario()"
                                        >
                                            Concluir
                                        </button>                            
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";
import api from '@/api/axios';

export default {
    computed: {
        isScrollable() {
            return true;
        },
        rowResponseQuestion() {

            let totalHeight = 0;
            for (let resposta of this.questaoAtual.Respostas) {
                if (resposta?.Descricao) {
                const characters = resposta.Descricao.length;
                const increments = Math.ceil(characters / 60);
                totalHeight += increments * 25; // Adiciona 50px à altura para cada incremento de 60 caracteres
                }
            }
            

            if(this.questaoAtual.Respostas == null || this.questaoAtual.Respostas.length == 0){
                return {
                    height: 140 + 'px'
                };
            }

           
            if(this.questaoAtual.Respostas.length > 6){
            return {
                height: '100%'
            };
            }

            if(this.questaoAtual.Respostas.length > 0 && this.questaoAtual.Respostas[0]?.Opcoes?.length == 0){
                let height = this.questaoAtual.Respostas.length * 30;

                if(totalHeight > height){
                    height = totalHeight;
                }

                return {
                    height: height + 'px'
                };
            }else{
                const height = this.questaoAtual.Respostas.length * 130;
                return {
                    height: height + 'px'
                };
            }
         },
         rowResponseModal() {

            if(this.questaoAtual == null){
                  return {
                      height: 400 + 'px'
                   };
            }

            if(this.questaoAtual.Respostas == null){
                    return {
                        height: 400 + 'px'
                    };
            }

            if(this.questaoAtual.Respostas.length < 5 && this.questaoAtual.Respostas.length > 0){


            let totalHeight = 300;
            for (let resposta of this.questaoAtual.Respostas) {
                if (resposta?.Descricao) {
                const characters = resposta.Descricao.length;
                const increments = Math.ceil(characters / 60);
                totalHeight += increments * 25; // Adiciona 50px à altura para cada incremento de 60 caracteres
                }
            }

            let heightRespostas = 300 + (this.questaoAtual.Respostas.length - 4) * 30;


           if(totalHeight > heightRespostas){
                heightRespostas = totalHeight;
            }

                    return {
                        height: heightRespostas > 600 ? heightRespostas+ 'px' : '600px'
                    };
            }

            if(this.questaoAtual.Respostas.length > 6){
                return {
                    height: '100%'
                };
            }

            if(this.questaoAtual.Respostas == null){
                const height = 400;
                return {
                    height: height + 'px'
                };
            }else if(this.questaoAtual.Respostas[0]?.Opcoes?.length == 0 || this.questaoAtual.Respostas[0]?.Opcoes?.length == undefined){
                
            let totalHeight = 0;
            for (let resposta of this.questaoAtual.Respostas) {
                if (resposta?.Descricao) {
                const characters = resposta.Descricao.length;
                const increments = Math.ceil(characters / 60);
                totalHeight += increments * 25; // Adiciona 50px à altura para cada incremento de 60 caracteres
                }
            }


            let heightRespostas = (this.questaoAtual.Respostas.length - 4) * 30;


           if(totalHeight > heightRespostas){
                heightRespostas = totalHeight;
            }
                
                const height = 400 + (heightRespostas);
                return {
                    height: height + 'px'
                };
            }else{
                return {
                    height: '100%'
                };
            }
        },
        ...mapGetters({
            showModalCreate: "GET_MODAL_QUESTIONARIO",
            listaQuestoes: 'GET_MODAL_LISTAR_QUESTIONARIO',
            user: 'auth/user',
        }),
    },
    data() {
    return {
        rowResponseHeight: 0,
        questionario: [],
        questaoAtual: {
            QuestionarioId: '',
            Pergunta: '',
            TipoCliente: '',
            TipoResposta: '',
            Respostas: []
        },
        numeroQuestao: 0,
        respostaQuestionario: {
            ClienteId: 0,
            Respostas: []
        },
        listaRespostasAtivas: []
     }
    },
    created(){

    },
    mounted() {
       this.$store.dispatch('FETCH_QUESTIONARIO_BUSCAR_QUESTOES');
       this.respostaQuestionario.ClienteId = this.user.ClienteId;
        this.listaRespostasAtivas = [];

    },
    watch: {
        listaQuestoes(){
            if (this.listaQuestoes && this.listaQuestoes.length > 0) {

                    // Filtra listaQuestoes para itens que correspondam ao TipoCliente do usuário
                    const questoesFiltradas = this.listaQuestoes.filter(questao => questao.TipoCliente === this.user.TipoCliente);

                    // Atualiza questionario e questaoAtual com as questões filtradas
                    if (questoesFiltradas.length > 0) {
                        this.questionario = questoesFiltradas;
                        this.questaoAtual = questoesFiltradas[0];
                    } else {
                    // Se nenhum item corresponder, você pode definir questionario e questaoAtual para valores padrão ou vazios
                        this.questionario = [];
                        this.questaoAtual = null; // ou {}, dependendo de como você quer lidar com "sem questões"
                    }
                }
        }
    },
    methods: {
        salvarAlteracoesLocalmente(QuestionarioRespostaId, QuestionarioId, OpcaoId, habilitarSubResposta){
          var removerResposta = false;
          
          this.resposta = { QuestionarioId: QuestionarioId, QuestionarioRespostaId: QuestionarioRespostaId, QuestionarioRespostaOpcaoId: OpcaoId > 0 ? OpcaoId : 0 };
            
            var index = -1;

            if(habilitarSubResposta){
                index = this.listaRespostasAtivas.findIndex(resposta => 
                resposta.QuestionarioRespostaId === QuestionarioRespostaId && resposta.QuestionarioId === QuestionarioId && resposta.QuestionarioRespostaOpcaoId === OpcaoId);
            }else{
                   index = this.respostaQuestionario.Respostas.findIndex(resposta => 
                 resposta.QuestionarioRespostaId === QuestionarioRespostaId && resposta.QuestionarioId === QuestionarioId && resposta.QuestionarioRespostaOpcaoId === OpcaoId);
            }

           if(index !== -1) {
              removerResposta = true;
              if(habilitarSubResposta){
                this.listaRespostasAtivas.splice(index, 1);
              }else{
              this.respostaQuestionario.Respostas.splice(index, 1);
              }
           }

          if(this.questaoAtual.TipoResposta == 'Única'){
            var indexUnico = this.respostaQuestionario.Respostas.findIndex(resposta => 
            resposta.QuestionarioId === QuestionarioId);

            if(indexUnico !== -1) {
                removerResposta = true;
                this.respostaQuestionario.Respostas.splice(indexUnico, 1);
            }
          }
          
          if(!removerResposta)
          {
            if(habilitarSubResposta){
                this.listaRespostasAtivas.push({ ...this.resposta });
                return;
            }

            this.respostaQuestionario.Respostas.push({ ...this.resposta });

          }else if(removerResposta && habilitarSubResposta){
            var indexSubResposta = 0

            while(indexSubResposta >= 0){
                 indexSubResposta = this.respostaQuestionario.Respostas.findIndex(resposta => 
                 resposta.QuestionarioRespostaId === QuestionarioRespostaId && resposta.QuestionarioId === QuestionarioId);
            if(indexSubResposta !== -1) {
                this.respostaQuestionario.Respostas.splice(indexSubResposta, 1);
               }
            }
          }

  
        },
        concluirQuestionario(){
            if(!this.capturarResposta())
            {
                    this.$swal({
                        icon: 'error',
                        title: 'Não preenchido',
                        text: `Necessário responder para avançar o questionário`,
                     });
                     return;
            }

            this.salvarFormulario();


        },
        capturarResposta(){
            // eslint-disable-next-line no-debugger
            debugger
            var indexUnico = this.respostaQuestionario.Respostas.findIndex(resposta => 
            resposta.QuestionarioId === this.questaoAtual.QuestionarioId);
   

            if(this.questaoAtual.Respostas[0]?.Opcoes?.length == 0 && indexUnico > -1){
                return true;
            }else if(this.questaoAtual.Respostas[0]?.Opcoes?.length > 0)
            {
                const quantidade = this.respostaQuestionario.Respostas.filter(resposta => 
                resposta.QuestionarioId === this.questaoAtual.QuestionarioId
                ).length;

                if(quantidade == this.questaoAtual.Respostas.length){
                    return true;
                }
            }

          return false;
        },
        limparRespostas(){
            this.questaoAtual.Respostas.forEach(resposta => {
                let inputElement = document.getElementById(resposta.QuestionarioRespostaId);
                if(inputElement) {
                    inputElement.checked = false;
                }
            });
        },
        proximaQuestao(){
            if(!this.capturarResposta()){
                    this.$swal({
                        icon: 'error',
                        title: 'Não preenchido',
                        text: `Necessário responder para avançar o questionário`,
                     });
                     return;
            }
            this.limparRespostas();
            this.numeroQuestao++;
            this.questaoAtual = this.questionario[this.numeroQuestao];

        },
        closeModal() {
            this.questaoAtual = this.questionario[0];
            this.numeroQuestao = 0;
            this.respostaQuestionario.Respostas = [];
            this.listaRespostasAtivas = [];
            this.$store.commit("SET_MODAL_QUESTIONARIO", false);
        },
        async salvarFormulario(){
             this.disableBtn = true;
             var encodedCredentials = btoa('sat@sat:sat23!');

                await api
                    .post('/suitability', this.respostaQuestionario, { headers: { 'Authorization': `Basic ${encodedCredentials}`}} )
                    .then((retorno) => {
                          
                        if(retorno.status == 200)
                        {
                          this.$swal({
                              icon: 'success',
                              title: 'Formulário preenchido com sucesso!',
                              text: 'Dados informados foram salvos com sucesso.',
                          });

                          this.$store.dispatch('FETCH_PERFIL_CLIENTE', this.user.ClienteId);
    
                          this.closeModal();
                        }
                    })
                    .catch((error) => {
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos',
                            text: `${error.response.data.data[0]}`,
                        });
                    });

        }
    },
};
</script>

<style lang="scss">
@include modal;

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.subTitle{
    color: #383333;;
    margin-top: -30px;
    margin-bottom: 30px; 
    font-size: large; 
    font-family: "Work Sans", sans-serif;
    font-weight: 400 !important;
}

.scrollable {
  margin-left: 10px;
  max-height: 300px; /* 6 x 20px */
  overflow-y: scroll;
}

.inner__modal_questionario{
    width: 450px;
}

.row-space-left{
    padding-left: 15px;
}

    .row-question{
        margin-bottom: 10px;
        height: 50px;
    }

    .row-response{
        margin-bottom: 10px;
        margin-left: 20px;
        height: 250px;
    }

.btnBlueQuestionario{
  height: 40px;
  font-family: 'Inter', sans-serif; /* Fonte Inter */
  background-color: #00235C;
  color: white;
  border: 1px solid #00235C; /* Borda */
  border-radius: 8px; /* Raio de borda */
  width: 210px;
  cursor: pointer;
}

.btnDefaultQuestionario{
  height: 40px;
  font-family: 'Inter', sans-serif; /* Fonte Inter */
  background-color: white;
  color: #344054;
  border: 1px solid #D0D5DD; /* Borda */
  margin-right: 35px;
  border-radius: 8px; /* Raio de borda */
  width: 210px;
  cursor: pointer;
}

.modal__mask .modal__wrapper .modal__container.reset {
        width: 600px;
        height: 400px;
}

.titleConta{
        font-weight: 800 !important;
        text-transform: uppercase;
}

.btnLogin{
    background-color: #565656 !important;
}

.subTitleCinza{
    width: 52%;
    text-align: center;
    font-weight: 400 !important;
    color: #707070 !important;
        font-family: "Work Sans", sans-serif;
}

.content__modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    .close__modal {
        position: absolute;
        right: 34px;
        top: 30px;
        font-family: "Montserrat";

        @media (max-width: 768px) {
            top: 16px;
            right: 16px;
        }
    }

    h3 {
        margin-bottom: 46px;

        @media (max-width: 768px) {
            font-size: 24px;
            margin-bottom: 20px;
            text-align: center;
            max-width: 280px;
        }
    }

    h2{
        color: var(--Gray-900, #101828);
        font-family: Inter;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
        margin-top: 0px;
        margin-bottom: 0px;
    }
}
</style>
